import Swal from 'sweetalert2';
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';

const ST = {
    New: 1,
    AwaitingPrint: 2,
    PendingReceipt: 3,
    Done: 4,
    Cancelled: 9,
};

export default {
    name: 'DirectDispatch',
    mixins: [HelperMixin],
    components: { PaginationHelper },

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails || !this.canDispenseFromMinistryUi()) {
            this.logout();
            return;
        }
        await this.loadLookups();
        this.GetInfo();
    },

    computed: {
        canManageDirectDispatch() {
            return this.canDispenseFromMinistryUi();
        },
        statsCards() {
            return [
                this.statCard('إجمالي السندات', this.pages, 'primary', 'ti ti-file-certificate'),
                this.statCard('سندات جديدة', this.countWhere(this.Info, row => Number(row.status) === ST.New), 'warning', 'ti ti-plus'),
                this.statCard('بانتظار الاستلام', this.countWhere(this.Info, row => Number(row.status) === ST.PendingReceipt), 'info', 'ti ti-hourglass'),
                this.statCard('سندات مكتملة', this.countWhere(this.Info, row => Number(row.status) === ST.Done), 'success', 'ti ti-circle-check'),
            ];
        },
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        },
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 15,
            pages: 0,
            Info: [],
            branchesList: [],
            productsList: [],
            filterFacilityId: null,
            filterStatus: null,
            createDialog: false,
            detailDialog: false,
            creating: false,
            createForm: {
                facilityBranchesId: null,
                note: '',
                lines: [{ productsId: null, quantity: 1 }],
            },
            detailRow: null,
        };
    },

    methods: {
        statusLabel(s) {
            switch (s) {
                case ST.New: return 'جديد';
                case ST.AwaitingPrint: return 'بانتظار الطباعة (خصم)';
                case ST.PendingReceipt: return 'بانتظار استلام المرفق';
                case ST.Done: return 'مكتمل';
                case ST.Cancelled: return 'ملغى';
                default: return s;
            }
        },

        async loadLookups() {
            try {
                const [b, p] = await Promise.all([
                    this.$http.GetAllBranches(),
                    this.$http.GetAllProducts(),
                ]);
                this.branchesList = b.data.info || [];
                this.productsList = p.data.info || [];
            } catch {
                this.branchesList = [];
                this.productsList = [];
            }
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo || 1;
            this.$blockUI.Start();
            this.$http.GetDirectDispatch(
                this.pageNo,
                this.pageSize,
                this.filterFacilityId || null,
                this.filterStatus != null && this.filterStatus !== '' ? this.filterStatus : null
            )
                .then((r) => {
                    this.$blockUI.Stop();
                    this.Info = r.data.info || [];
                    this.pages = r.data.count || 0;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                });
        },

        addLine() {
            this.createForm.lines.push({ productsId: null, quantity: 1 });
        },
        removeLine(idx) {
            if (this.createForm.lines.length <= 1) return;
            this.createForm.lines.splice(idx, 1);
        },

        openCreate() {
            this.createForm = {
                facilityBranchesId: null,
                note: '',
                lines: [{ productsId: null, quantity: 1 }],
            };
            this.createDialog = true;
        },

        submitCreate() {
            if (!this.createForm.facilityBranchesId) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'اختر المرفق الصحي.');
                return;
            }
            const lines = this.createForm.lines
                .filter((l) => l.productsId && l.quantity > 0)
                .map((l) => ({ productsId: l.productsId, quantity: parseInt(l.quantity, 10) }));
            if (!lines.length) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'أضف سطراً واحداً على الأقل بصنف وكمية صالحة.');
                return;
            }
            this.creating = true;
            this.$http.DirectDispatchCreate({
                facilityBranchesId: this.createForm.facilityBranchesId,
                note: this.createForm.note || '',
                lines,
            })
                .then((r) => {
                    this.creating = false;
                    this.createDialog = false;
                    this.$helper.ShowMessage('success', 'تم', `تم إنشاء السند ${r.data.code || ''}`);
                    this.GetInfo(1);
                })
                .catch((err) => {
                    this.creating = false;
                    this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : 'فشل الإنشاء');
                });
        },

        openDetail(row) {
            this.$blockUI.Start();
            this.$http.GetDirectDispatchOne(row.id)
                .then((r) => {
                    this.$blockUI.Stop();
                    this.detailRow = r.data;
                    this.detailDialog = true;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        doConfirm(id) {
            Swal.fire({
                title: 'تأكيد السند',
                text: 'سيتم اعتماد السند للانتقال إلى مرحلة الطباعة والخصم.',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'تأكيد',
                cancelButtonText: 'إلغاء',
            }).then((res) => {
                if (!res.isConfirmed) return;
                this.$blockUI.Start();
                this.$http.DirectDispatchConfirm(id)
                    .then(() => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'تم', 'تم التأكيد.');
                        this.GetInfo(this.pageNo);
                        if (this.detailDialog && this.detailRow && this.detailRow.id === id) this.openDetail({ id });
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : '');
                    });
            });
        },

        doPrint(id) {
            Swal.fire({
                title: 'تنفيذ الخصم وإرسال للمرفق',
                text: 'سيتم خصم الكميات من المخزن الرئيسي (FIFO) وإرسال السند للمرفق للاستلام.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'تنفيذ',
                cancelButtonText: 'إلغاء',
            }).then((res) => {
                if (!res.isConfirmed) return;
                this.$blockUI.Start();
                this.$http.DirectDispatchPrint(id)
                    .then((r) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'تم', typeof r.data === 'string' ? r.data : 'تم الخصم.');
                        this.GetInfo(this.pageNo);
                        if (this.detailDialog && this.detailRow && this.detailRow.id === id) this.openDetail({ id });
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : '');
                    });
            });
        },

        doCancel(id) {
            Swal.fire({
                title: 'إلغاء السند',
                input: 'text',
                inputPlaceholder: 'سبب الإلغاء (اختياري)',
                showCancelButton: true,
                confirmButtonText: 'إلغاء السند',
                cancelButtonText: 'رجوع',
            }).then((res) => {
                if (!res.isConfirmed) return;
                const reason = (res.value != null ? String(res.value) : '') || '';
                this.$blockUI.Start();
                this.$http.DirectDispatchCancel(id, reason)
                    .then(() => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'تم', 'تم إلغاء السند.');
                        this.detailDialog = false;
                        this.GetInfo(this.pageNo);
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : '');
                    });
            });
        },
    },
};
